<template>
  <div class="section section-details is-paddingless" v-if="titreRecette">
    <div class="entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">
                {{ titleRecette }}
              </h1>
              <breadcrumb :breadcrumb="breadcrumb" />
            </div>
          </div>
        </div>
        <a ref="lienDownload"></a>
        <div class="level-right">
          <div class="buttons">
            <router-link
              :to="routeToForEdit"
              :class="{'button-access-no-permission': !checkPermissions(permTitreRecette.maj)}"
              class="button is-addOrEdit">
              {{ $t('general.button.edit') }}
            </router-link>
            <qd-button v-if="titreRecette.etat === brouillon"
              class="button is-addOrEdit"
              :class="{'button-access-no-permission':
              !checkPermissions(permTitreRecette.maj)}"
              @click="checkPermissions(permTitreRecette.maj) ?
            isTitreRecetteDefinitifOpen = true : showPopUp()">
              {{ $t('general.button.save') }}
            </qd-button>
          <dropdownButton
            v-if="peutEtreAnnule"
            type="is-addOrEdit"
            class="mgr-2"
            :permission="permTitreRecette.maj"
            :actions="actionSecondary"
            @click="popupAvoirShow = true">
              {{ $t('detailTitreRecette.actions.avoir') }}
          </dropdownButton>
          <qd-button v-else-if="peutRepasserBrouillon()"
            class="button is-addOrEdit"
            :class="{'button-access-no-permission':
            !checkPermissions(permTitreRecette.maj)}"
            @click="checkPermissions(permTitreRecette.maj) ?
              isTitreRecetteBrouillonOpen = true : showPopUp()">
            {{ $t('detailTitreRecette.actions.draft') }}
          </qd-button>
          <qd-button class="button">
            <b-dropdown position="is-bottom-left" aria-role="list">
              <a slot="trigger">
                <b-icon class="is-flex"
                  custom-class="has-text-icon-more"
                  icon="dots-vertical">
                </b-icon>
              </a>
              <b-dropdown-item
                @click="checkPermissions(permTitreRecette.maj) ?
                generateEcritureComptable() : showPopUp()">
                {{ $t('detailTitreRecette.actions.generateEcriture') }}
              </b-dropdown-item>
            </b-dropdown>
          </qd-button>
          <piece-jointe-button
            class="mgr-2"
            :perm="permTitreRecette.maj"
            autoSave>
          </piece-jointe-button>
          </div>
        </div>
      </div>
      <div class="tab">
        <ul>
          <li @click="activeTab = 'titreRecette'"
            :class="{'is-active': activeTab === 'titreRecette'}">
            {{ $t('detailTitreRecette.onglet.titreRecette')}}
          </li>
          <li @click="activeTab = 'ecrituresCompta'"
            :class="{'is-active': activeTab === 'ecrituresCompta'}">
            {{ $t('detailTitreRecette.onglet.ecritureComptable')}}
          </li>
          <li
            v-if="!isAvoir"
            :class="{'is-active': activeTab === 'rapprochement'}"
            @click="activeTab = 'rapprochement'">
            <b-field>
              <div class="mgv-auto mgr-5px" :class="getColorStatusRapprochement"></div>
              <span>{{ $t('detailTitreRecette.onglet.rapprochement') }}</span>
            </b-field>
          </li>
        </ul>
      </div>
    </div>

    <component :is="activeTab"
      :moduleType="MODULE_TLPE"
      :isEdit="false"
      ref="componentChild"
      :dcf="titreRecette"
      :detailDevisCommande="titreRecetteDetail"
      :devisCommande="titreRecette"
      :id="titreRecette.id"
      :commandeAchatRapprocher="commandeAchatRapprocher"
      :dateDernierExport="titreRecette.dernierExportComptable"
      :ecritures="ecritures"
    ></component>

    <b-modal v-model="isTitreRecetteBrouillonOpen"
      has-modal-card
      class="modal"
      width="25vw"
      @close="isTitreRecetteBrouillonOpen = false; error = false; messages = []">
      <pop-up-prevention
      :messagesPopup="messages"
      :isErrorPopup.sync="error"
      :messHeader="$t('detailTitreRecette.toDraftBillTitle', { code: titreRecette.code })"
      :messDescription="$t('detailTitreRecette.toDraftBillText')"
      :cancel="$t('general.button.cancel')"
      :validate="$t('detailTitreRecette.actions.draft')"
      @no="isTitreRecetteBrouillonOpen = false; error = false; messages = []"
      @yes="repassageBrouillon()"/>
    </b-modal>
    <b-modal v-model="isTitreRecetteDefinitifOpen"
      has-modal-card
      class="modal"
      width="25vw"
      @close="isTitreRecetteDefinitifOpen = false">
      <confirmation-enregistrement-definitif
        :isAvoir="isAvoir"
        :facture="titreRecette"
        isTitreRecette/>
    </b-modal>
    <b-modal v-model="popupAvoirShow"
      has-modal-card
      class="modal"
      width="25vw">
      <pop-up-avoir-titre-recette
        :titreRecette="titreRecette"
        :commandeAchatRapprocher="commandeAchatRapprocher"/>
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import breadcrumb from '@/components/general/breadcrumb';
import dropdownButton from '@/components/general/button/dropdownButton';
import { generateByFacture, getByFacture } from '@/api/compta/ifEcriture';
import messageErreur from '@/services/general/messageErreur';
import validationDevisCommande from '@/services/devisCommandes/validation/validation';
import * as devisConf from '@/configuration/devisConf';
import ecrituresCompta from '@/components/commun/ecritureComptable/ecrituresComptaDetail';
import { get, facture2Brouillon as facture2BrouillonAchat } from '@/api/factureAchatARapprocher/index';
import getInfoEcheancierPaiement from '@/services/echeancePaiement/getInformationEcheancierPaiement';
import rapprochement from '@/components/baux/factureAchatARapprocher/detail/detailRapprochement';
import detailDevisCommande from '@/services/devisCommandes/detailDevisCommande';
import { get as getTiers } from '@/api/tiers';
import titreRecette from '@/components/factures/factureDetail';
import { TITRE_RECETTE } from '@/configuration/gabed/permissionsGabedConf';
import { TYPE_ACHAT } from '@/configuration/compta/ecritureConf';
import confirmationEnregistrementDefinitif from '@/components/factures/confirmationEnregistrementDefinitif';
import inProgress from '@/services/general/inProgress';
import messageSucces from '@/services/general/messageSucces';
import { PARAMETRES_KEYS } from '@/store/modules/parametres-mutation-type';
import * as types from '@/store/modules/facture-mutation-type';
import calculArrondi from '@/services/calcul/calculArrondi';
import {
  SOUS_TYPE_AVOIR,
  SOUS_TYPE_AVOIR_SUR_ACOMPTE,
  TOTAL_RAPPROCHEMENT,
  PARTIEL_RAPPROCHEMENT,
  NO_RAPPROCHEMENT,
} from '@/configuration/facture/factureConf';
import popUpAvoirTitreRecette from '@/components/gabed/titreRecette/popUpAvoirTitreRecette';
import popUpPrevention from '@/components/general/popUpPrevention';
import pieceJointeButton from '@/components/general/button/pieceJointeButton';
import {
  MODULE_TLPE,
} from '@/configuration/gabed/titreRecette/titreRecetteConf';
import { initializeCommandeAchatRapprochement } from '@/services/achat/factures/factureAchatServices';

const Attachments = createNamespacedHelpers('attachments');
const permissions = createNamespacedHelpers('permissions');
const Parametres = createNamespacedHelpers('parametres');
const factures = createNamespacedHelpers('facture');

export default {
  name: 'c_titreRecette',
  components: {
    breadcrumb,
    ecrituresCompta,
    titreRecette,
    dropdownButton,
    rapprochement,
    confirmationEnregistrementDefinitif,
    popUpAvoirTitreRecette,
    popUpPrevention,
    pieceJointeButton,
  },
  data() {
    return {
      messages: [],
      error: false,
      activeTab: 'titreRecette',
      titreRecette: null,
      titreRecetteDetail: null,
      permTitreRecette: TITRE_RECETTE,
      brouillon: devisConf.ETAT_BROUILLON,
      isTitreRecetteDefinitifOpen: false,
      isTitreRecetteBrouillonOpen: false,
      commandeAchatRapprocher: [],
      popupAvoirShow: false,
      ecritures: [],
      MODULE_TLPE,
      TOTAL_RAPPROCHEMENT,
    };
  },
  methods: {
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
    }),
    ...Parametres.mapActions({
      loadParametres: 'loadParametres',
    }),
    ...permissions.mapActions({
      showPopUp: 'showPopup',
    }),
    ...factures.mapMutations({
      setAvoirACreer: types.SET_AVOIR_A_CREER,
    }),
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    async repassageBrouillon() {
      const loadingComponent = this.$buefy.loading.open();
      this.messages = [];
      this.error = false;
      try {
        await facture2BrouillonAchat(this.titreRecette.id);
        loadingComponent.close();
        await this.$router.go(0);
      } catch (e) {
        if (e.response) {
          this.error = true;
          validationDevisCommande(e.response,
            this.messages,
            false,
            this.isAvoir ? devisConf.SOUS_TYPE_AVOIR : devisConf.TYPE_FACTURE);
          loadingComponent.close();
          return;
        }
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
    async generateEcritureComptable() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await generateByFacture(this.titreRecette.id, TYPE_ACHAT);
        this.ecritures = (await getByFacture(this.titreRecette.id,
          this.titreRecette.sens)).data.result;
        messageSucces(this.$t('detailTitreRecette.messages.success.generateEcriture'));
      } catch (e) {
        messageErreur(this.$i18n);
        throw (e);
      } finally {
        loadingComponent.close();
      }
    },
    peutRepasserBrouillon() {
      return this.titreRecette.etat === devisConf.ETAT_ENREGISTRE
        && this.ecritures.every(ecriture => !ecriture.ifLotId);
    },
    addCommandeAchatDejaLettre(rapprochements) {
      this.commandeAchatRapprocher = initializeCommandeAchatRapprochement(
        rapprochements,
        this.$route.params.id,
      );
    },
  },
  computed: {
    ...permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    titleRecette() {
      if (this.isAvoir) {
        return this.$t('detailTitreRecette.titleAvoir', { code: this.titreRecette.code });
      }
      return this.$t('detailTitreRecette.title', { code: this.titreRecette.code });
    },
    montantAvoir() {
      const t = this.titreRecette.avoirsAffectes
        .map(a => Math.abs(a.montantHt))
        .reduce((partialSum, a) => partialSum + a, 0);
      return t;
    },
    montantARapprocher() {
      return this.titreRecette.montantHt - this.montantAvoir;
    },
    statutRapprochement() {
      if (this.commandeAchatRapprocher.length === 0) return NO_RAPPROCHEMENT;
      const montantAffecter = this.commandeAchatRapprocher
        .map((echeance) => echeance.montantAffecter)
        .reduce((a, b) => calculArrondi(a + b));
      if (montantAffecter === this.montantARapprocher && this.montantARapprocher > 0) {
        return TOTAL_RAPPROCHEMENT;
      }
      if (montantAffecter < this.montantARapprocher || this.montantARapprocher === 0) {
        return PARTIEL_RAPPROCHEMENT;
      }
      return NO_RAPPROCHEMENT;
    },
    getColorStatusRapprochement() {
      switch (this.statutRapprochement) {
        case TOTAL_RAPPROCHEMENT:
          return 'round-circle-success';
        case PARTIEL_RAPPROCHEMENT:
          return 'round-circle-warning';
        case NO_RAPPROCHEMENT:
          return 'round-circle-danger';
        default:
          return 'round-circle-danger';
      }
    },
    breadcrumb() {
      return [
        { title: this.$t('general.breadcrumb.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('detailTitreRecette.breadcrumb.listeTitreRecette'), route: { name: 'l.gabed.titre_recette' }, isActive: false },
        { title: this.$t('detailTitreRecette.breadcrumb.detailTitreRecette'), route: '', isActive: true },
      ];
    },
    actionSecondary() {
      const actions = [];
      if (this.peutRepasserBrouillon()) {
        actions.push(
          {
            label: this.$t('detailTitreRecette.actions.draft'),
            action: () => { this.isTitreRecetteBrouillonOpen = true; },
            permissionAction: this.permTitreRecette.maj,
          },
        );
      }
      return actions;
    },
    isAvoir() {
      return [SOUS_TYPE_AVOIR, SOUS_TYPE_AVOIR_SUR_ACOMPTE]
        .includes(this.titreRecette.sousType);
    },
    peutEtreAnnule() {
      return this.titreRecette
        && this.titreRecette.sousType === devisConf.SOUS_TYPE_NORMAL
        && (this.titreRecette.etat === devisConf.ETAT_ENREGISTRE
        || this.titreRecette.etat === devisConf.ETAT_PAYE)
        && this.statutRapprochement !== TOTAL_RAPPROCHEMENT;
    },
    isBrouillon() {
      return this.titreRecette.etat === devisConf.ETAT_BROUILLON;
    },
    routeToForEdit() {
      let nameRoute = 'm.gabed.titre_recette-edition';
      if (!this.isBrouillon) {
        nameRoute = 'm.gabed.titre_recette-save-to-edit';
      }
      return {
        name: nameRoute,
        params: { id: this.titreRecette.id },
      };
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.setAttachmentContext({ module: 'TitreRecette' });
      await this.loadParametres([PARAMETRES_KEYS.categorieGroupeProduitDeductible]);
      this.titreRecette = (await get(this.$route.params.id)).data.result;
      await this.setAttachmentElementId({ id: this.titreRecette.id });
      this.ecritures = (await getByFacture(this.titreRecette.id,
        this.titreRecette.sens)).data.result;
      this.titreRecette.echeancierPaiement = await getInfoEcheancierPaiement(
        this.titreRecette.echeancierPaiement,
      );
      const detailTitreRecette = detailDevisCommande(this.titreRecette);
      detailTitreRecette.rapprochements = this.titreRecette.rapprochements;
      detailTitreRecette.destinataireComptable.compteComptable = (
        await getTiers(detailTitreRecette.destinataireComptable.tiersId)
      ).data.result.compteComptable;
      this.addCommandeAchatDejaLettre(detailTitreRecette.rapprochements);
      this.titreRecetteDetail = detailTitreRecette;
    } catch (e) {
      messageErreur(this.$i18n);
      throw (e);
    } finally {
      loadingComponent.close();
    }
    this.setInformationPage(this.$t('pageGeneral.detail', { item: this.titreRecette.code }));
  },
};
</script>

<style scoped>

</style>
